import React from 'react';
import HamburgerMenu from '../global/menu';
import '../global/styles.css';

function PatientCareGuidelines({ userInfo, isAdmin, onLogout, onNavigate }) {
  return (
    <div className="container-center" style={{ paddingBottom: '80px' }}>
      {/* Hamburger Menu */}
      <HamburgerMenu
        isAdmin={isAdmin}
        onLogout={onLogout}
        onNavigate={onNavigate}
      />

      <div className="card card-center" style={{
        maxWidth: '900px',
        width: '100%',
        padding: '50px 40px'
      }}>
        {/* Header Container */}
        <div style={{
          textAlign: 'center',
          marginBottom: '40px',
          borderBottom: '2px solid #0E3293',
          paddingBottom: '30px'
        }}>
          <h1 style={{
            fontSize: '36px',
            fontWeight: 'bold',
            color: '#0E3293',
            margin: '0 0 15px 0',
            letterSpacing: '-0.5px'
          }}>
            Patient Care Guidelines
          </h1>
          <h2 style={{
            fontSize: '22px',
            color: '#555',
            fontWeight: '500',
            margin: '0 0 10px 0'
          }}>
            Version: January 2025
          </h2>
          <p style={{
            fontSize: '16px',
            color: '#777',
            margin: '0',
            lineHeight: '1.6'
          }}>
            To access, click on the patient care guidelines below.
          </p>
        </div>

        {/* FlippingBook Embed */}
        <div style={{
          background: '#f8f9fa',
          padding: '30px',
          borderRadius: '12px',
          marginBottom: '20px',
          boxShadow: 'inset 0 2px 8px rgba(0, 0, 0, 0.05)'
        }}>
          <a
            href="https://studyguide.passwithpass.com/s/nLQFuHvrdy96ExdK"
            target="_blank"
            rel="noopener noreferrer"
            style={{
              maxWidth: '100%',
              display: 'block',
              color: '#0E3293',
              fontSize: '18px',
              textDecoration: 'none',
              fontWeight: '500',
              transition: 'color 0.2s ease'
            }}
          >
            2025 Mayo Clinic Ambulance Service Patient Care Guidelines
          </a>
        </div>
      </div>

      {/* Fixed Footer */}
      <footer style={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        width: '100%',
        background: '#ffffff',
        textAlign: 'center',
        padding: '15px 10px',
        boxShadow: '0 -2px 10px rgba(0,0,0,0.08)',
        zIndex: 9999,
        borderTop: '1px solid #e0e0e0'
      }}>
        <div style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          gap: '10px',
          flexWrap: 'wrap'
        }}>
          <img
            src="https://us.api.fliplet.com/v1/media/files/5174683/contents/blob"
            alt="NarcoticTrack Logo"
            style={{
              height: '32px',
              verticalAlign: 'middle'
            }}
          />
          <span style={{
            fontSize: '14px',
            color: '#666',
            fontWeight: '400'
          }}>
            © 2025 NarcoticTrack Inventory System, LLC
          </span>
        </div>
      </footer>
    </div>
  );
}

export default PatientCareGuidelines;
